import { workflows } from '../../models/common.ts'
import type { PredefinedDateRange } from '../../models/date-range.ts'
import {
  vArray,
  vDateRange,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
} from '../../validation/index.ts'

export const loadUsageTypes = ['booked', 'quoted'] as const
export type LoadUsageType = (typeof loadUsageTypes)[number]

export const accountUsageRanges = [
  'last-7-days',
  'last-30-days',
  'this-month',
  'last-3-months',
  'last-12-months',
  'this-year',
] as const satisfies readonly PredefinedDateRange[]

export const DEFAULT_ACCOUNT_USAGE_RANGE = 'last-12-months' as const

export const accountUsageQuerySchema = vObject({
  range: vOptional(vPicklist(accountUsageRanges), DEFAULT_ACCOUNT_USAGE_RANGE),
})

export type AccountUsageQuery = vOutput<typeof accountUsageQuerySchema>

export const usageStats = [
  'active-users',
  'loads-quoted',
  'loads-booked',
  'olark-chats',
] as const
export type UsageStatType = (typeof usageStats)[number]

export const DEFAULT_USAGE_STAT_RANGE: PredefinedDateRange = 'today'

export const usageStatQuerySchema = vObject({
  stat: vPicklist(usageStats),
  range: vOptional(vDateRange(), DEFAULT_USAGE_STAT_RANGE),
  accountId: vOptional(vObjectId()),
  userId: vOptional(vObjectId()),
  workflows: vOptional(vArray(vPicklist(workflows))),
})

export type UsageStatQuery = vOutput<typeof usageStatQuerySchema>

export type UsageStatResult = { value: number }

export type UsageAnomalyRow = {
  accountId: string
  companyName: string
  subscriptionPlan: string
  subscriptionEnds: string | null
  bookedCurrent: number
  bookedAvg: number
  bookedChange: number
}

export type UsageAnomalyResult = {
  currentPeriod: string
  historicalPeriod: string
  rows: UsageAnomalyRow[]
}
